import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import {
  environment as params
} from "src/environments/environment";
import * as moment from "moment";

declare var $: any;

@Component({
  selector: "app-plan-side",
  templateUrl: "./plan-side.component.html",
  styleUrls: ["./plan-side.component.scss"]
})
export class PlanSideComponent implements OnInit {
  @Input("prod") prod: any = null;
  @Input("totalViajeros") totalViajeros: any = null;
  @Input("totalNormal") totalNormal: any = null;
  @Input("totalIsic") totalIsic: any = null;
  @Input("customers") customers: any = [];
  @Output("total") total: EventEmitter<any> = new EventEmitter<any>();
  public dataTable: any;
  public totalSum: any = 0;
  public url: String = '';
  public addOnSelected: any;
  public insuranceSelected;
  public _moment: any;
  public numberOfUsers: any = [];
  public addPrice: any = 0;
  public product: any;
  public detailsUsersAndOnds: any = [];
  urlBaseMJ: any = (<any>params).api.mj;

  constructor() {
    this.dataTable = JSON.parse(localStorage.getItem("planes"));
    this.addOnSelected = sessionStorage.getItem("addOns")
      ? JSON.parse(sessionStorage.getItem("addOns"))
      : null;
    this.product = JSON.parse(sessionStorage.getItem("product"));

    this.addPrice = this.addOnSelected
      ? this.addOnSelected.reduce(
          (carry, actual) => Number(carry) + Number(actual.localPrice),
          0
        )
      : 0;

    moment.locale("es");
    this._moment = moment;
  }

  ngOnInit() {
    this.url = location.origin + sessionStorage.getItem('url');
    const { selectedProduct, vouchers } = JSON.parse(
      sessionStorage.getItem('product')
    );
    const quantity = selectedProduct
      ? selectedProduct.quantity
      : vouchers[0].quantity;
    this.totalSum =
      (this.prod ? this.prod.totalPrice : 0) +
      (this.addOnSelected
        ? this.addOnSelected.reduce(
            (carry, actual) =>
              Number(carry) + Number(actual.localPrice / quantity),
            0
          )
        : 0);

    for (let i = 0; i < quantity; i++) {
      this.numberOfUsers.push(`Viajero ${i + 1}`);
    }

    const newArr = this.numberOfUsers.map(user => {
      const traveler = [];
      const listOns = this.addOnSelected.filter(ons => user === ons.customer);
      traveler.push({
        product: {
          ...this.product,
          totalPrice: this.product.totalPrice / this.numberOfUsers.length
        },
        addOns: listOns.map(ons => {
          return {
            ...ons,
            localPrice: ons.localPrice / this.numberOfUsers.length
          };
        }),
        customer: user
      });
      return traveler;
    });

    this.detailsUsersAndOnds = newArr.flat();
  }

  collapseDetails(event) {
    event.preventDefault();
    $.fn.extend({
      toggleText: function(a, b) {
        return this.text(this.text() == b ? a : b);
      }
    });

    $("#container_collapse_details").toggleClass("list_collapse");
    $("#container_collapse_details_mobile").toggleClass("list_collapse");
    $("#btn_collpaseble").toggleText(
      "ocultar cobertura",
      "ver cobertura completa"
    );
    $("#btn_collpaseble_mobile").toggleText(
      "ocultar cobertura",
      "ver cobertura completa"
    );
  }

  copyUrlSearch() {
    let element = document.getElementById("url_search") as HTMLInputElement;
    element.select();
    document.execCommand("copy");
    element.setSelectionRange(0, 0);
  }

  ngAfterViewInit(): void {
    this.toPay();
  }

  toPay() {
    this.total.emit(this.totalSum);
  }
}
